/*
 *  THIS COMPONENT IS DEPRECATED
 *  Please use 'CurrencySelect' from /components instead
 */
import { SmartSelect, SmartSelectProps } from '@components-deprecated'

import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useCurrencies } from '../../../../hooks'
import { getItemsForSelect } from '../../../../utils/forms'
import { Currency } from '../types'

export type CurrencySelectorProps = SmartSelectProps<Currency> & {
  currency?: string
}

export const CurrencySelector = ({
  currency,
  name = 'currency_selector',
  listWidth,
  ...rest
}: CurrencySelectorProps) => {
  const { t } = useTranslation()
  const { data } = useCurrencies()

  const items = useMemo(() => {
    const currencies = data?.currencies || []
    return getItemsForSelect<Currency>(currencies, 'id', 'name')
  }, [data?.currencies])

  return (
    <SmartSelect<Currency>
      items={items}
      name={name}
      listWidth={listWidth || 238}
      notFoundText={t('app.currencies.currency_selector.not_found')}
      placeholder={t('app.currencies.currency_selector.select_currency')}
      selectFirst
      {...rest}
    />
  )
}
